<template>
  <section class="px-14 sm-max:px-5">
    <div class="mb-2 text-center sm-max:leading-3" v-if="extraButtonTopText">
      <span v-html="buttonTextTopBold" class="font-bold sm:text-xl text-12" />


      <br class="block sm:hidden">
      <span v-if="!extraButtonBottomText" class="italic sm:text-base text-12" v-html="buttonTextTopSmall">

      </span>
    </div>
    <div class="mx-auto" :style="maxWidth ? `max-width: ${maxWidth}` : ''">
      <ButtonHealthyIcon :text="buttonText" :scrollTrigger :newStyle="newStyle" :dataAttrs="{
        'data-event-label': buttonLabel,
        'data-event-action': buttonAction,
        'data-event-name': buttonEvent
      }" />
    </div>

    <div v-if="extraButtonBottomText" class="mt-1 italic text-center sm:text-base text-12" v-html="buttonTextTopSmall">

    </div>
  </section>
</template>

<script setup>

defineProps({
  buttonText: {
    type: String,
    default: 'ADD TO CART'
  },
  extraButtonTopText: {
    type: Boolean,
    default: false
  },
  buttonTextTopBold: {
    type: String,
    default: 'LIMITED TIME OFFER: Get 50% off your first order (discount auto-applied)'
  },
  buttonTextTopSmall: {
    type: String,
    default: '(discount auto-applied)'
  },
  extraButtonBottomText: {
    type: Boolean,
    default: false
  },
  buttonLabel: {
    type: String
  },
  buttonAction: {
    type: String
  },
  buttonEvent: {
    type: String,
    default: 'experiment_event'
  },
  scrollTrigger: {
    type: String,
    default: "the-products"
  },
  maxWidth: {
    type: String,
    default: '800px'
  },
  newStyle: {
    type: Boolean,
    default: false
  }
})


defineBuilderComponent({
  friendlyName: "ButtonWithIcon",
  canHaveChildren: true,
  inputs: [
    {
      name: "buttonText",
      type: "text",
      defaultValue: "ADD TO CART"
    },
    {
      name: "extraButtonTopText",
      type: "boolean",
      defaultValue: false
    },
    {
      name: "buttonTextTopBold",
      type: "richText",
      defaultValue: "LIMITED TIME OFFER: Get 50% off your first order"
    },
    {
      name: "buttonTextTopSmall",
      type: "richText",
      defaultValue: "(discount auto-applied)"
    },
    {
      name: "extraButtonBottomText",
      type: "boolean",
      defaultValue: false
    },
    {
      name: "buttonLabel",
      type: "string"
    },
    {
      name: "buttonAction",
      type: "string"
    },
    {
      name: "buttonEvent",
      type: "string",
      defaultValue: "experiment_event"
    },
    {
      name: "scrollTrigger",
      type: "string",
      defaultValue: "the-products"
    },
    {
      name: "maxWidth",
      type: "string",
      defaultValue: "800px",
      helperText: "Set max width (e.g., '800px', '100%', or leave empty to remove limit)"
    },
    {
      name: "newStyle",
      type: "boolean",
      defaultValue: false
    }
  ]
});
</script>